import React, { useState, useEffect } from 'react';
import { ic } from './trackingUtils';

const VehicleTrackingVehiclePicker = ({
  isOpen,
  onClose,
  anchorEl,
  vehicles,
  selectedRegs,
  onApply,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [draftSelected, setDraftSelected] = useState(new Set(selectedRegs || []));

  useEffect(() => {
    if (isOpen) {
      setDraftSelected(new Set(selectedRegs || []));
      setSearchQuery('');
    }
  }, [isOpen, selectedRegs]);

  if (!isOpen) return null;

  const isAll = draftSelected.size === 0;

  const filtered = vehicles.filter((v) => {
    if (!searchQuery) return true;
    const q = searchQuery.toLowerCase().replace(/[-\s]/g, '');
    return (
      v.reg.toLowerCase().replace(/[-\s]/g, '').includes(q) ||
      (v.drv && v.drv.toLowerCase().replace(/[-\s]/g, '').includes(q))
    );
  });

  const toggleSelect = (reg) => {
    const next = new Set(draftSelected);
    if (next.has(reg)) {
      next.delete(reg);
    } else {
      next.add(reg);
    }
    setDraftSelected(next);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setDraftSelected(new Set());
    }
  };

  const handleClear = () => {
    setDraftSelected(new Set());
  };

  const handleApply = () => {
    onApply(Array.from(draftSelected));
    onClose();
  };

  let popStyle = {};
  if (anchorEl) {
    const rect = anchorEl.getBoundingClientRect();
    const width = Math.min(340, window.innerWidth - 24);
    const left = Math.max(12, Math.min(window.innerWidth - width - 12, rect.left));
    const top = rect.bottom + 6;
    popStyle = {
      position: 'fixed',
      zIndex: 1500,
      width: `${width}px`,
      left: `${left}px`,
      top: `${top}px`,
      maxHeight: `${Math.max(240, window.innerHeight - rect.bottom - 20)}px`,
    };
  }

  return (
    <>
      <div
        className="fp-scrim"
        onClick={onClose}
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 1490,
          background: 'rgba(16, 5, 46, 0.2)',
        }}
      />
      <div
        className="vp-pop"
        style={popStyle}
        role="dialog"
        aria-label="Choose vehicles"
      >
        <div className="vp-search">
          <span
            dangerouslySetInnerHTML={{ __html: ic('search', 'width="14" height="14"') }}
            style={{ position: 'absolute', left: '18px', top: '50%', transform: 'translateY(-50%)', color: '#7076C2' }}
          />
          <input
            className="input"
            id="vpq"
            placeholder="Search reg. no. or driver"
            autoComplete="off"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <label className="vp-all">
          <input
            type="checkbox"
            checked={isAll}
            onChange={handleSelectAll}
          />
          <b>All vehicles</b>
          <span className="muted">
            {vehicles.filter((v) => !v.suspended).length} active
          </span>
        </label>

        <div className="vp-list" id="vplist">
          {filtered.map((v) => (
            <label key={v.reg} className="vp-item">
              <input
                type="checkbox"
                checked={draftSelected.has(v.reg)}
                onChange={() => toggleSelect(v.reg)}
              />
              <b>{v.reg}</b>
              <span className={`cat ${v.cat}`}>{v.cat}</span>
              <span className="muted">
                {v.drv}
                {v.suspended ? ' · suspended' : ''}
              </span>
            </label>
          ))}
        </div>

        <div className="vp-foot">
          <span className="muted" id="vpn">
            {draftSelected.size ? `${draftSelected.size} selected` : 'All vehicles'}
          </span>
          <button type="button" className="btn sm" onClick={handleClear}>
            Clear
          </button>
          <button type="button" className="btn sm primary" onClick={handleApply}>
            Apply
          </button>
        </div>
      </div>
    </>
  );
};

export default VehicleTrackingVehiclePicker;
